import React from 'react';
import { ListGroup } from 'reactstrap';
import SideNavItem from './SideNavItem';
import { TSideNavItem } from './types';

interface SideNavProps {
  items: TSideNavItem[];
}

const SideNav: React.FC<SideNavProps> = ({
  items,
}) => {
  return (
    <ListGroup
      className="side-nav rounded-0"
    >
      {items && items.filter(item => {
          if (typeof item === 'string') return true;
          if ('isActive' in item) return item.isActive;
          return true;
        })
        .map(item => {
        if (typeof item === 'string') {
          return (
            <SideNavItem
              key={item}
              label={item}
            />
          );
        }

        return (
          <SideNavItem
            key={item.label}
            {...item}
          />
        );
      })}
    </ListGroup>
  );
};

export default SideNav;
